import { render, staticRenderFns } from "./PayPanel.vue?vue&type=template&id=b3a428f0&scoped=true&"
import script from "./PayPanel.vue?vue&type=script&lang=js&"
export * from "./PayPanel.vue?vue&type=script&lang=js&"
import style0 from "./PayPanel.vue?vue&type=style&index=0&id=b3a428f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a428f0",
  null
  
)

export default component.exports